import api from '../services/api';

/**
 * Points API client
 */
export const pointsAPI = {
  /**
   * Get current student's points
   */
  getPoints: async () => {
    try {
      const response = await api.get('users/points/');
      return response.data;
    } catch (error) {
      if (error.response?.data?.message === 'HANDLED_LIMIT') {
        return { xp: 0, gems: 0, total_xp: 0 };
      }
      throw error;
    }
  },

  /**
   * Award points for an activity
   * @param {Object} data - { amount_xp, amount_gems, reason, related_object_type, related_object_id }
   */
  awardPoints: async (data) => {
    const response = await api.post('users/points/activity/', data);
    return response.data;
  },

  /**
   * Claim daily login bonus
   */
  claimDailyLogin: async () => {
    const response = await api.post('users/points/daily-login/');
    return response.data;
  },

  /**
   * Buy heart refill with gems (5 gems = 1 heart)
   */
  buyHeartRefill: async () => {
    const response = await api.post('users/points/heart-refill/');
    return response.data;
  },

  /**
   * Get points transaction history
   * @param {Object} params - Query parameters (optional)
   */
  getHistory: async (params = {}) => {
    const response = await api.get('users/points/history/', { params });
    return response.data;
  },
};
